var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"6","x2":"24","y2":"6","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("line",{"y1":"12","x2":"24","y2":"12","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("line",{"y1":"18","x2":"24","y2":"18","stroke":"currentColor","strokeWidth":"2","key":2})]);
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
